import ApiClient from './ApiClient';

class DddAssignmentsAPI extends ApiClient {
  constructor() {
    super('ddd_assignments', { accountScoped: true });
  }
}

export default new DddAssignmentsAPI();
